import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import NumberSettingsContext from './NumberSettingsContext'
import {displayNumber} from 'utils'

class NumberDisplay extends PureComponent {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    decimalSeparator: PropTypes.string,
    thousandsSeparator: PropTypes.string,
  }

  static defaultProps = {
    decimalSeparator: '.',
    thousandsSeparator: ',',
  }

  get displayValue() {    
    const {blank, children, prefix, suffix, decimalSeparator, thousandsSeparator} = this.props
    if (blank && (!children || Number(children) === 0)) {
      return blank
    }
    const value = (!children && children !== 0) ? '' : children.toString()
    const number = displayNumber(value, {decimalSeparator, thousandsSeparator})
    return `${prefix ? `${prefix}` : ''}${number}${suffix ? ` ${suffix}` : ''}`
  }

  render = () =>
    <span>{this.displayValue}</span>

}

export default class NumberDisplayWrapper extends PureComponent {
  static propTypes = NumberDisplay.propTypes

  render = () =>
    <NumberSettingsContext.Consumer>{value => <NumberDisplay {...value} {...this.props} />}</NumberSettingsContext.Consumer>
}
